import { BundleProps, ProductData } from 'utils/types';
import { StyledDecaBundle } from './styles';
import { BundlePrice } from 'components/BundlePrice';
import { EBundlesInternalViewModel, EProductPriority } from 'utils/enums';
import { useEffect, useState } from 'react';
import { SubProduct } from './SubProduct';
import { MainProduct } from './MainProduct';

export const DecaBundle: React.FC<BundleProps> = ({
  prices,
  productList,
  backgroundSrc,
  backgroundColor = { colorOne: '#880000' },
  bundleButtonColor,
  bundleButtonTextColor,
  inMobileMock = false,
  traits = [],
  bundleTitle = '',
  bundleSubtitle = '',
}) => {
  const [mainProduct, setMainProduct] = useState<ProductData | null>(null);
  const [subProducts, setSubProducts] = useState<ProductData[]>([]);

  useEffect(() => {
    if (!productList || productList.length === 0) return;

    setMainProduct(
      productList.find(
        (product) => product.priority === EProductPriority.MAIN,
      ) ?? null,
    );

    setSubProducts(
      productList.filter(
        (product) => product.priority === EProductPriority.SUB,
      ) ?? [],
    );
  }, [productList]);

  return (
    <StyledDecaBundle>
      <div className="container">
        <button
          className="tooltip"
          style={{
            width: '16px',
            height: '16px',
            background: '#CB9E50',
            borderRadius: '50%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            color: '#fff',
            border: 'none',
            marginLeft: 'auto',
          }}
        >
          i
        </button>
        <div className="mainProductContainer">
          <div className="title">{bundleTitle}</div>
          <MainProduct
            product={mainProduct?.images?.product}
            traits={traits}
            backgroundSrc={backgroundSrc}
            backgroundColor={backgroundColor}
          />
          <div className="subtitle">{bundleSubtitle}</div>
        </div>
        <div className="subProducts">
          <div className="subProducts__scroll">
            {subProducts.map(
              ({ textFontColorHex, quantityDisplay, images }, index) => (
                <SubProduct
                  key={index}
                  product={images?.product}
                  quantityDisplay={quantityDisplay}
                  textFontColorHex={textFontColorHex}
                />
              ),
            )}
          </div>
        </div>
      </div>
      <BundlePrice
        prices={prices}
        buttonTextColor={bundleButtonTextColor}
        type={EBundlesInternalViewModel.DECA}
        buttonColor={bundleButtonColor}
        borderRadius="4px"
        isPreview={inMobileMock}
        isTextAutoResized
      />
    </StyledDecaBundle>
  );
};
